import { useState, useRef, useEffect } from 'react';

const languages = [
  { code: 'es', label: 'Español', flag: '🇪🇸' },
  { code: 'en', label: 'English', flag: '🇬🇧' },
  { code: 'ru', label: 'Русский', flag: '🇷🇺' },
  { code: 'pl', label: 'Polski', flag: '🇵🇱' },
  { code: 'fr', label: 'Français', flag: '🇫🇷' },
  { code: 'de', label: 'Deutsch', flag: '🇩🇪' },
  { code: 'pt', label: 'Português', flag: '🇵🇹' },
  { code: 'it', label: 'Italiano', flag: '🇮🇹' },
];

const translations: Record<string, Record<string, string>> = {
  es: {
    nav_inicio: 'Inicio', nav_destacados: 'Destacados', nav_propiedades: 'Propiedades',
    nav_mapa: 'Mapa', nav_contacto: 'Contacto', nav_nosotros: 'Nosotros', nav_ubicacion: 'Ubicación',
    nav_cta: 'Contáctanos', back: 'Volver al listado',
    hero_title: 'Tu próximo hogar empieza aquí',
    hero_sub: 'En Red Lions Realty, convertimos tus sueños inmobiliarios en realidad. Propiedades de alta calidad en las mejores ubicaciones de Alicante.',
    hero_btn1: 'Ver Propiedades', hero_btn2: 'Contactar',
    contact_label: 'WhatsApp', email_label: 'Email', location_label: 'Ubicación',
    videos_badge: 'Videos',
    videos_title: '🎬 Destacados',
    videos_sub: 'Mira nuestras propiedades en video y descubre todos los detalles',
    videos_btn: 'Ver video en TikTok',
    videos_more: 'Ver más en TikTok',
    video1_type: 'Alquiler · Local Comercial',
    video1_desc: 'El local comercial que estás buscando',
    video2_type: 'Disponible · Local Comercial',
    video2_desc: '¿Buscas local para tu negocio?',
    props_title: '🏠 Listado de Propiedades',
    props_sub: 'Descubre nuestras mejores ofertas en venta y alquiler',
    props_found: 'propiedad encontrada',
    props_found_pl: 'propiedades encontradas',
    props_active_filters: '· Filtros activos',
    props_sorted: 'Ordenado por relevancia',
    props_see_detail: 'Ver detalle',
    props_gallery: 'Galería de fotos',
    props_see_photos: 'Ver fotos',
    props_none_title: 'No se encontraron propiedades',
    props_none_sub: 'Intenta ajustar los filtros para ver más resultados.',
    contact_title: '¿Listo para encontrar tu próximo hogar?',
    contact_sub: 'Contáctanos hoy y comienza tu búsqueda con los mejores profesionales',
    contact_name: 'Tu nombre',
    contact_email: 'Tu email',
    contact_phone: 'Tu teléfono',
    contact_message: 'Cuéntanos qué tipo de propiedad buscas...',
    contact_send: 'Enviar Mensaje',
    contact_sending: 'Enviando...',
    contact_success: '¡Mensaje enviado con éxito! Te contactaremos pronto.',
    contact_error: 'Error al enviar el mensaje. Por favor, intenta de nuevo.',
    about_badge: 'Sobre Nosotros',
    about_title: 'Red Lions Realty es tu socio de confianza en el mercado inmobiliario de Alicante ✨',
    about_sub: 'Con años de experiencia en el sector, nos especializamos en ofrecer propiedades de alta calidad en las mejores ubicaciones. Nuestro equipo de profesionales está comprometido con brindarte un servicio personalizado y transparente en cada paso del proceso.',
    about_mission_title: 'Nuestra Misión',
    about_mission_text: 'Ayudar a nuestros clientes a encontrar la propiedad perfecta adaptada a sus necesidades y presupuesto, ofreciendo un servicio excepcional y asesoramiento experto.',
    about_vision_title: 'Nuestra Visión',
    about_vision_text: 'Ser la agencia inmobiliaria líder en Alicante, reconocida por nuestra integridad, profesionalismo y compromiso con la satisfacción del cliente.',
    about_values_title: 'Nuestros Valores',
    about_values_text: 'Transparencia, honestidad y dedicación en cada transacción. Construimos relaciones duraderas basadas en la confianza y el respeto mutuo.',
    why_title: '¿Por qué elegirnos?',
    why_sub: 'Ofrecemos un servicio integral y personalizado para garantizar tu satisfacción',
    why1_title: 'Búsqueda Personalizada',
    why1_text: 'Encontramos la propiedad perfecta según tus necesidades específicas y presupuesto',
    why2_title: 'Transparencia Total',
    why2_text: 'Sin sorpresas ni costos ocultos. Te acompañamos en cada paso del proceso',
    why3_title: 'Atención Excepcional',
    why3_text: 'Disponibles para ti en todo momento, respondiendo todas tus dudas y consultas',
    location_badge: 'Nuestra Ubicación',
    location_title: 'Encuéntranos aquí',
    location_sub: 'Visítanos en nuestra oficina en Hurchillo, Alicante. Estamos aquí para ayudarte a encontrar tu propiedad ideal.',
    location_address_label: 'Dirección',
    location_phone_label: 'Teléfono / WhatsApp',
    location_email_label: 'Email',
    location_hours_label: 'Horario de Atención',
    location_hours1: 'Lunes – Viernes: 9:00 – 19:00',
    location_hours2: 'Sábados: 10:00 – 14:00',
    location_directions: 'Cómo llegar',
    location_desc: 'Nos encontramos en la esquina frente a la iglesia, justo al lado del Banco Caja Rural, en el centro de Hurchillo.',
    blog_title: 'Nuestro Blog',
    blog_sub: 'Consejos, guías y novedades sobre el mercado inmobiliario en la Costa Blanca',
    blog_read_more: 'Leer más',
    blog_see_all: 'Ver todos los artículos',
    testimonials_badge: 'Testimonios',
    testimonials_title: 'Lo que dicen\nnuestros clientes',
    footer_newsletter_title: 'Mantente informado',
    footer_newsletter_sub: 'Suscríbete a nuestro boletín y recibe las últimas propiedades y ofertas exclusivas directamente en tu correo.',
    footer_newsletter_placeholder: 'tu@email.com',
    footer_newsletter_btn: 'Suscribirse',
    footer_newsletter_sending: 'Enviando...',
    footer_newsletter_success: '¡Suscripción exitosa!',
    footer_newsletter_error: 'Error en la suscripción. Intenta de nuevo.',
    footer_nav_label: 'Navegación',
    footer_contact_label: 'Contacto',
    footer_privacy: 'Privacidad',
    footer_terms: 'Términos',
    footer_rights: '© 2025 Red Lions Realty. Todos los derechos reservados.',
    nav_inicio_label: 'Inicio', nav_destacados_label: 'Destacados',
    nav_propiedades_label: 'Propiedades', nav_mapa_label: 'Mapa',
    nav_contacto_label: 'Contacto', nav_nosotros_label: 'Sobre Nosotros',
    // Blog page
    blog_page_title: 'Blog Inmobiliario',
    blog_page_sub: 'Guías, consejos y novedades sobre el mercado inmobiliario en la Costa Blanca',
    blog_search_placeholder: 'Buscar artículos...',
    blog_cat_all: 'Todas',
    blog_results_singular: 'artículo encontrado',
    blog_results_plural: 'artículos encontrados',
    blog_no_results_title: 'No se encontraron artículos',
    blog_no_results_sub: 'Intenta con otros términos de búsqueda o categorías',
    blog_read_article: 'Leer artículo',
    blog_footer_tagline: 'Tu socio de confianza en el mercado inmobiliario de la Costa Blanca',
    blog_footer_links: 'Enlaces',
    blog_footer_follow: 'Síguenos',
    // Blog post page
    blogpost_back: 'Volver al blog',
    blogpost_share: 'Compartir:',
    blogpost_share_liked: '¿Te gustó? Compártelo:',
    blogpost_copy: 'Copiar enlace',
    blogpost_copied: '¡Copiado!',
    blogpost_cta_title: '¿Listo para encontrar tu propiedad ideal?',
    blogpost_cta_sub: 'En Red Lions Realty te ayudamos a encontrar la propiedad perfecta en la Costa Blanca',
    blogpost_cta_btn: 'Ver propiedades',
    blogpost_related: 'Artículos relacionados',
    blogpost_read_article: 'Leer artículo',
    blogpost_not_found: 'Artículo no encontrado',
    blogpost_back_blog: 'Volver al blog',
    blogpost_nav_home: 'Inicio',
    blogpost_nav_blog: 'Blog',
    blogpost_nav_contact: 'Contáctanos',
    blogpost_footer_tagline: 'Tu socio de confianza en bienes raíces en la Costa Blanca',
    blogpost_footer_contact: 'Contacto',
    blogpost_footer_offices: 'Oficinas',
    blogpost_footer_follow: 'Síguenos',
    blogpost_footer_rights: '© 2025 Red Lions Realty. Todos los derechos reservados.',
    // Property page
    prop_back: 'Volver al listado',
    prop_not_found_title: 'Propiedad no encontrada',
    prop_not_found_sub: 'La propiedad que buscas no existe o ha sido eliminada.',
    prop_not_found_btn: 'Volver al inicio',
    prop_info_bedrooms: 'Habitaciones',
    prop_info_bathrooms: 'Baños',
    prop_info_area: 'Superficie',
    prop_info_location: 'Ubicación',
    prop_info_description: 'Descripción',
    prop_info_details: 'Detalles de la propiedad',
    prop_info_operation: 'Tipo de operación',
    prop_info_reference: 'Referencia',
    prop_contact_price_note: 'Precio orientativo. Consulta disponibilidad.',
    prop_contact_whatsapp: 'Consultar por WhatsApp',
    prop_contact_form_title: 'Solicitar información',
    prop_contact_name: 'Tu nombre',
    prop_contact_email: 'Tu email',
    prop_contact_phone: 'Tu teléfono',
    prop_contact_interested: 'Me interesa:',
    prop_contact_send: 'Enviar consulta',
    prop_contact_sending: 'Enviando...',
    prop_contact_success: '¡Mensaje enviado con éxito! Te contactaremos pronto.',
    prop_contact_error: 'Error al enviar. Inténtalo de nuevo.',
    prop_footer_rights: '© 2025 Red Lions Realty. Todos los derechos reservados.',
  },
  en: {
    nav_inicio: 'Home', nav_destacados: 'Featured', nav_propiedades: 'Properties',
    nav_mapa: 'Map', nav_contacto: 'Contact', nav_nosotros: 'About Us', nav_ubicacion: 'Location',
    nav_cta: 'Contact Us', back: 'Back to listings',
    hero_title: 'Your next home starts here',
    hero_sub: 'At Red Lions Realty, we turn your real estate dreams into reality. High-quality properties in the best locations in Alicante.',
    hero_btn1: 'View Properties', hero_btn2: 'Contact',
    contact_label: 'WhatsApp', email_label: 'Email', location_label: 'Location',
    videos_badge: 'Videos',
    videos_title: '🎬 Featured',
    videos_sub: 'Watch our properties on video and discover all the details',
    videos_btn: 'Watch on TikTok',
    videos_more: 'See more on TikTok',
    video1_type: 'For Rent · Commercial Space',
    video1_desc: 'The commercial space you\'re looking for',
    video2_type: 'Available · Commercial Space',
    video2_desc: 'Looking for a space for your business?',
    props_title: '🏠 Property Listings',
    props_sub: 'Discover our best offers for sale and rent',
    props_found: 'property found',
    props_found_pl: 'properties found',
    props_active_filters: '· Active filters',
    props_sorted: 'Sorted by relevance',
    props_see_detail: 'View detail',
    props_gallery: 'Photo gallery',
    props_see_photos: 'View photos',
    props_none_title: 'No properties found',
    props_none_sub: 'Try adjusting the filters to see more results.',
    contact_title: 'Ready to find your next home?',
    contact_sub: 'Contact us today and start your search with the best professionals',
    contact_name: 'Your name',
    contact_email: 'Your email',
    contact_phone: 'Your phone',
    contact_message: 'Tell us what type of property you\'re looking for...',
    contact_send: 'Send Message',
    contact_sending: 'Sending...',
    contact_success: 'Message sent successfully! We\'ll contact you soon.',
    contact_error: 'Error sending message. Please try again.',
    about_badge: 'About Us',
    about_title: 'Red Lions Realty is your trusted partner in the Alicante real estate market ✨',
    about_sub: 'With years of experience in the sector, we specialize in offering high-quality properties in the best locations. Our team of professionals is committed to providing you with personalized and transparent service at every step.',
    about_mission_title: 'Our Mission',
    about_mission_text: 'To help our clients find the perfect property that fits their needs and budget, offering exceptional service and expert advice.',
    about_vision_title: 'Our Vision',
    about_vision_text: 'To be the leading real estate agency in Alicante, recognized for our integrity, professionalism and commitment to client satisfaction.',
    about_values_title: 'Our Values',
    about_values_text: 'Transparency, honesty and dedication in every transaction. We build lasting relationships based on trust and mutual respect.',
    why_title: 'Why choose us?',
    why_sub: 'We offer a comprehensive and personalized service to guarantee your satisfaction',
    why1_title: 'Personalized Search',
    why1_text: 'We find the perfect property according to your specific needs and budget',
    why2_title: 'Full Transparency',
    why2_text: 'No surprises or hidden costs. We accompany you at every step of the process',
    why3_title: 'Exceptional Service',
    why3_text: 'Available for you at all times, answering all your questions and queries',
    location_badge: 'Our Location',
    location_title: 'Find us here',
    location_sub: 'Visit us at our office in Hurchillo, Alicante. We are here to help you find your ideal property.',
    location_address_label: 'Address',
    location_phone_label: 'Phone / WhatsApp',
    location_email_label: 'Email',
    location_hours_label: 'Opening Hours',
    location_hours1: 'Monday – Friday: 9:00 – 19:00',
    location_hours2: 'Saturdays: 10:00 – 14:00',
    location_directions: 'Get directions',
    location_desc: 'We are located on the corner opposite the church, right next to Banco Caja Rural, in the center of Hurchillo.',
    blog_title: 'Our Blog',
    blog_sub: 'Tips, guides and news about the real estate market on the Costa Blanca',
    blog_read_more: 'Read more',
    blog_see_all: 'View all articles',
    testimonials_badge: 'Testimonials',
    testimonials_title: 'What our\nclients say',
    footer_newsletter_title: 'Stay informed',
    footer_newsletter_sub: 'Subscribe to our newsletter and receive the latest properties and exclusive offers directly in your inbox.',
    footer_newsletter_placeholder: 'your@email.com',
    footer_newsletter_btn: 'Subscribe',
    footer_newsletter_sending: 'Sending...',
    footer_newsletter_success: 'Subscription successful!',
    footer_newsletter_error: 'Subscription error. Please try again.',
    footer_nav_label: 'Navigation',
    footer_contact_label: 'Contact',
    footer_privacy: 'Privacy',
    footer_terms: 'Terms',
    footer_rights: '© 2025 Red Lions Realty. All rights reserved.',
    nav_inicio_label: 'Home', nav_destacados_label: 'Featured',
    nav_propiedades_label: 'Properties', nav_mapa_label: 'Map',
    nav_contacto_label: 'Contact', nav_nosotros_label: 'About Us',
    blog_page_title: 'Real Estate Blog',
    blog_page_sub: 'Guides, tips and news about the real estate market on the Costa Blanca',
    blog_search_placeholder: 'Search articles...',
    blog_cat_all: 'All',
    blog_results_singular: 'article found',
    blog_results_plural: 'articles found',
    blog_no_results_title: 'No articles found',
    blog_no_results_sub: 'Try other search terms or categories',
    blog_read_article: 'Read article',
    blog_footer_tagline: 'Your trusted partner in the Costa Blanca real estate market',
    blog_footer_links: 'Links',
    blog_footer_follow: 'Follow us',
    blogpost_back: 'Back to blog',
    blogpost_share: 'Share:',
    blogpost_share_liked: 'Did you like it? Share it:',
    blogpost_copy: 'Copy link',
    blogpost_copied: 'Copied!',
    blogpost_cta_title: 'Ready to find your ideal property?',
    blogpost_cta_sub: 'At Red Lions Realty, we help you find the perfect property on the Costa Blanca',
    blogpost_cta_btn: 'View properties',
    blogpost_related: 'Related articles',
    blogpost_read_article: 'Read article',
    blogpost_not_found: 'Article not found',
    blogpost_back_blog: 'Back to blog',
    blogpost_nav_home: 'Home',
    blogpost_nav_blog: 'Blog',
    blogpost_nav_contact: 'Contact Us',
    blogpost_footer_tagline: 'Your trusted partner in real estate on the Costa Blanca',
    blogpost_footer_contact: 'Contact',
    blogpost_footer_offices: 'Offices',
    blogpost_footer_follow: 'Follow us',
    blogpost_footer_rights: '© 2025 Red Lions Realty. All rights reserved.',
    prop_back: 'Back to listings',
    prop_not_found_title: 'Property not found',
    prop_not_found_sub: 'The property you are looking for does not exist or has been removed.',
    prop_not_found_btn: 'Back to home',
    prop_info_bedrooms: 'Bedrooms',
    prop_info_bathrooms: 'Bathrooms',
    prop_info_area: 'Area',
    prop_info_location: 'Location',
    prop_info_description: 'Description',
    prop_info_details: 'Property details',
    prop_info_operation: 'Operation type',
    prop_info_reference: 'Reference',
    prop_contact_price_note: 'Indicative price. Check availability.',
    prop_contact_whatsapp: 'Ask on WhatsApp',
    prop_contact_form_title: 'Request information',
    prop_contact_name: 'Your name',
    prop_contact_email: 'Your email',
    prop_contact_phone: 'Your phone',
    prop_contact_interested: 'I\'m interested in:',
    prop_contact_send: 'Send enquiry',
    prop_contact_sending: 'Sending...',
    prop_contact_success: 'Message sent! We\'ll contact you soon.',
    prop_contact_error: 'Error sending. Please try again.',
    prop_footer_rights: '© 2025 Red Lions Realty. All rights reserved.',
  },
  ru: {
    nav_inicio: 'Главная', nav_destacados: 'Избранное', nav_propiedades: 'Недвижимость',
    nav_mapa: 'Карта', nav_contacto: 'Контакт', nav_nosotros: 'О нас', nav_ubicacion: 'Расположение',
    nav_cta: 'Связаться', back: 'Назад к списку',
    hero_title: 'Ваш следующий дом начинается здесь',
    hero_sub: 'В Red Lions Realty мы воплощаем ваши мечты о недвижимости в реальность. Качественная недвижимость в лучших районах Аликанте.',
    hero_btn1: 'Смотреть объекты', hero_btn2: 'Связаться',
    contact_label: 'WhatsApp', email_label: 'Эл. почта', location_label: 'Расположение',
    videos_badge: 'Видео',
    videos_title: '🎬 Избранное',
    videos_sub: 'Смотрите наши объекты на видео и узнайте все детали',
    videos_btn: 'Смотреть в TikTok',
    videos_more: 'Больше в TikTok',
    video1_type: 'Аренда · Коммерческое помещение',
    video1_desc: 'Коммерческое помещение, которое вы ищете',
    video2_type: 'Доступно · Коммерческое помещение',
    video2_desc: 'Ищете помещение для бизнеса?',
    props_title: '🏠 Список объектов',
    props_sub: 'Откройте для себя лучшие предложения по продаже и аренде',
    props_found: 'объект найден',
    props_found_pl: 'объектов найдено',
    props_active_filters: '· Активные фильтры',
    props_sorted: 'Сортировка по релевантности',
    props_see_detail: 'Подробнее',
    props_gallery: 'Фотогалерея',
    props_see_photos: 'Смотреть фото',
    props_none_title: 'Объекты не найдены',
    props_none_sub: 'Попробуйте изменить фильтры для просмотра большего количества результатов.',
    contact_title: 'Готовы найти свой следующий дом?',
    contact_sub: 'Свяжитесь с нами сегодня и начните поиск с лучшими специалистами',
    contact_name: 'Ваше имя',
    contact_email: 'Ваш email',
    contact_phone: 'Ваш телефон',
    contact_message: 'Расскажите, какой тип недвижимости вы ищете...',
    contact_send: 'Отправить сообщение',
    contact_sending: 'Отправка...',
    contact_success: 'Сообщение успешно отправлено! Мы свяжемся с вами.',
    contact_error: 'Ошибка отправки. Пожалуйста, попробуйте снова.',
    about_badge: 'О нас',
    about_title: 'Red Lions Realty — ваш надёжный партнёр на рынке недвижимости Аликанте ✨',
    about_sub: 'Имея многолетний опыт в отрасли, мы специализируемся на предложении качественной недвижимости в лучших локациях. Наша команда профессионалов обеспечивает персонализированный и прозрачный сервис на каждом этапе.',
    about_mission_title: 'Наша миссия',
    about_mission_text: 'Помогать клиентам найти идеальный объект, соответствующий их потребностям и бюджету, предлагая исключительный сервис и экспертные консультации.',
    about_vision_title: 'Наше видение',
    about_vision_text: 'Стать ведущим агентством недвижимости в Аликанте, известным своей честностью, профессионализмом и приверженностью удовлетворённости клиентов.',
    about_values_title: 'Наши ценности',
    about_values_text: 'Прозрачность, честность и преданность делу в каждой сделке. Мы строим долгосрочные отношения на основе доверия и взаимного уважения.',
    why_title: 'Почему выбирают нас?',
    why_sub: 'Мы предлагаем комплексный и персонализированный сервис для вашего полного удовлетворения',
    why1_title: 'Персональный подбор',
    why1_text: 'Находим идеальный объект в соответствии с вашими конкретными потребностями и бюджетом',
    why2_title: 'Полная прозрачность',
    why2_text: 'Никаких сюрпризов и скрытых расходов. Сопровождаем вас на каждом этапе',
    why3_title: 'Исключительный сервис',
    why3_text: 'Доступны для вас в любое время, отвечаем на все ваши вопросы',
    location_badge: 'Наше расположение',
    location_title: 'Найдите нас здесь',
    location_sub: 'Посетите наш офис в Урчильо, Аликанте. Мы здесь, чтобы помочь вам найти идеальный объект.',
    location_address_label: 'Адрес',
    location_phone_label: 'Телефон / WhatsApp',
    location_email_label: 'Эл. почта',
    location_hours_label: 'Часы работы',
    location_hours1: 'Пн – Пт: 9:00 – 19:00',
    location_hours2: 'Суббота: 10:00 – 14:00',
    location_directions: 'Как добраться',
    location_desc: 'Мы находимся на углу напротив церкви, рядом с Banco Caja Rural, в центре Урчильо.',
    blog_title: 'Наш блог',
    blog_sub: 'Советы, руководства и новости о рынке недвижимости на Коста-Бланка',
    blog_read_more: 'Читать далее',
    blog_see_all: 'Все статьи',
    testimonials_badge: 'Отзывы',
    testimonials_title: 'Что говорят\nнаши клиенты',
    footer_newsletter_title: 'Будьте в курсе',
    footer_newsletter_sub: 'Подпишитесь на нашу рассылку и получайте последние объекты и эксклюзивные предложения прямо на почту.',
    footer_newsletter_placeholder: 'ваш@email.com',
    footer_newsletter_btn: 'Подписаться',
    footer_newsletter_sending: 'Отправка...',
    footer_newsletter_success: 'Подписка оформлена!',
    footer_newsletter_error: 'Ошибка подписки. Попробуйте снова.',
    footer_nav_label: 'Навигация',
    footer_contact_label: 'Контакт',
    footer_privacy: 'Конфиденциальность',
    footer_terms: 'Условия',
    footer_rights: '© 2025 Red Lions Realty. Все права защищены.',
    nav_inicio_label: 'Главная', nav_destacados_label: 'Избранное',
    nav_propiedades_label: 'Недвижимость', nav_mapa_label: 'Карта',
    nav_contacto_label: 'Контакт', nav_nosotros_label: 'О нас',
    blog_page_title: 'Блог о недвижимости',
    blog_page_sub: 'Руководства, советы и новости о рынке недвижимости на Коста-Бланка',
    blog_search_placeholder: 'Поиск статей...',
    blog_cat_all: 'Все',
    blog_results_singular: 'статья найдена',
    blog_results_plural: 'статей найдено',
    blog_no_results_title: 'Статьи не найдены',
    blog_no_results_sub: 'Попробуйте другие поисковые запросы или категории',
    blog_read_article: 'Читать статью',
    blog_footer_tagline: 'Ваш надёжный партнёр на рынке недвижимости Коста-Бланка',
    blog_footer_links: 'Ссылки',
    blog_footer_follow: 'Подписывайтесь',
    blogpost_back: 'Назад в блог',
    blogpost_share: 'Поделиться:',
    blogpost_share_liked: 'Понравилось? Поделитесь:',
    blogpost_copy: 'Копировать ссылку',
    blogpost_copied: 'Скопировано!',
    blogpost_cta_title: 'Готовы найти идеальный объект?',
    blogpost_cta_sub: 'В Red Lions Realty мы поможем вам найти идеальную недвижимость на Коста-Бланка',
    blogpost_cta_btn: 'Смотреть объекты',
    blogpost_related: 'Похожие статьи',
    blogpost_read_article: 'Читать статью',
    blogpost_not_found: 'Статья не найдена',
    blogpost_back_blog: 'Назад в блог',
    blogpost_nav_home: 'Главная',
    blogpost_nav_blog: 'Блог',
    blogpost_nav_contact: 'Связаться',
    blogpost_footer_tagline: 'Ваш надёжный партнёр в сфере недвижимости на Коста-Бланка',
    blogpost_footer_contact: 'Контакт',
    blogpost_footer_offices: 'Офисы',
    blogpost_footer_follow: 'Подписывайтесь',
    blogpost_footer_rights: '© 2025 Red Lions Realty. Все права защищены.',
    prop_back: 'Назад к списку',
    prop_not_found_title: 'Объект не найден',
    prop_not_found_sub: 'Объект, который вы ищете, не существует или был удален.',
    prop_not_found_btn: 'На главную',
    prop_info_bedrooms: 'Спальни',
    prop_info_bathrooms: 'Ванные',
    prop_info_area: 'Площадь',
    prop_info_location: 'Расположение',
    prop_info_description: 'Описание',
    prop_info_details: 'Детали объекта',
    prop_info_operation: 'Тип операции',
    prop_info_reference: 'Референс',
    prop_contact_price_note: 'Ориентировочная цена. Уточните наличие.',
    prop_contact_whatsapp: 'Спросить в WhatsApp',
    prop_contact_form_title: 'Запросить информацию',
    prop_contact_name: 'Ваше имя',
    prop_contact_email: 'Ваш email',
    prop_contact_phone: 'Ваш телефон',
    prop_contact_interested: 'Меня интересует:',
    prop_contact_send: 'Отправить запрос',
    prop_contact_sending: 'Отправка...',
    prop_contact_success: 'Сообщение отправлено! Мы свяжемся с вами.',
    prop_contact_error: 'Ошибка отправки. Попробуйте снова.',
    prop_footer_rights: '© 2025 Red Lions Realty. Все права защищены.',
  },
  pl: {
    nav_inicio: 'Strona główna', nav_destacados: 'Wyróżnione', nav_propiedades: 'Nieruchomości',
    nav_mapa: 'Mapa', nav_contacto: 'Kontakt', nav_nosotros: 'O nas', nav_ubicacion: 'Lokalizacja',
    nav_cta: 'Skontaktuj się', back: 'Powrót do listy',
    hero_title: 'Twój następny dom zaczyna się tutaj',
    hero_sub: 'W Red Lions Realty zamieniamy Twoje marzenia o nieruchomościach w rzeczywistość. Wysokiej jakości nieruchomości w najlepszych lokalizacjach Alicante.',
    hero_btn1: 'Zobacz nieruchomości', hero_btn2: 'Kontakt',
    contact_label: 'WhatsApp', email_label: 'E-mail', location_label: 'Lokalizacja',
    videos_badge: 'Filmy',
    videos_title: '🎬 Wyróżnione',
    videos_sub: 'Oglądaj nasze nieruchomości na wideo i odkryj wszystkie szczegóły',
    videos_btn: 'Obejrzyj na TikTok',
    videos_more: 'Więcej na TikTok',
    video1_type: 'Wynajem · Lokal użytkowy',
    video1_desc: 'Lokal użytkowy, którego szukasz',
    video2_type: 'Dostępny · Lokal użytkowy',
    video2_desc: 'Szukasz lokalu dla swojej firmy?',
    props_title: '🏠 Lista nieruchomości',
    props_sub: 'Odkryj nasze najlepsze oferty sprzedaży i wynajmu',
    props_found: 'nieruchomość znaleziona',
    props_found_pl: 'nieruchomości znalezionych',
    props_active_filters: '· Aktywne filtry',
    props_sorted: 'Posortowane według trafności',
    props_see_detail: 'Zobacz szczegóły',
    props_gallery: 'Galeria zdjęć',
    props_see_photos: 'Zobacz zdjęcia',
    props_none_title: 'Nie znaleziono nieruchomości',
    props_none_sub: 'Spróbuj dostosować filtry, aby zobaczyć więcej wyników.',
    contact_title: 'Gotowy znaleźć swój następny dom?',
    contact_sub: 'Skontaktuj się z nami i rozpocznij poszukiwania z najlepszymi specjalistami',
    contact_name: 'Twoje imię',
    contact_email: 'Twój e-mail',
    contact_phone: 'Twój telefon',
    contact_message: 'Powiedz nam, jakiego rodzaju nieruchomości szukasz...',
    contact_send: 'Wyślij wiadomość',
    contact_sending: 'Wysyłanie...',
    contact_success: 'Wiadomość wysłana pomyślnie! Skontaktujemy się wkrótce.',
    contact_error: 'Błąd wysyłania. Spróbuj ponownie.',
    about_badge: 'O nas',
    about_title: 'Red Lions Realty to Twój zaufany partner na rynku nieruchomości w Alicante ✨',
    about_sub: 'Dzięki wieloletniemu doświadczeniu specjalizujemy się w oferowaniu wysokiej jakości nieruchomości w najlepszych lokalizacjach. Nasz zespół profesjonalistów zapewnia spersonalizowaną i przejrzystą obsługę na każdym etapie.',
    about_mission_title: 'Nasza misja',
    about_mission_text: 'Pomagamy klientom znaleźć idealną nieruchomość dopasowaną do ich potrzeb i budżetu, oferując wyjątkową obsługę i doradztwo ekspertów.',
    about_vision_title: 'Nasza wizja',
    about_vision_text: 'Być wiodącą agencją nieruchomości w Alicante, uznaną za uczciwość, profesjonalizm i zaangażowanie w satysfakcję klienta.',
    about_values_title: 'Nasze wartości',
    about_values_text: 'Przejrzystość, uczciwość i zaangażowanie w każdej transakcji. Budujemy trwałe relacje oparte na zaufaniu i wzajemnym szacunku.',
    why_title: 'Dlaczego nas wybrać?',
    why_sub: 'Oferujemy kompleksową i spersonalizowaną obsługę, aby zagwarantować Twoje zadowolenie',
    why1_title: 'Spersonalizowane wyszukiwanie',
    why1_text: 'Znajdziemy idealną nieruchomość zgodnie z Twoimi potrzebami i budżetem',
    why2_title: 'Pełna przejrzystość',
    why2_text: 'Żadnych niespodzianek ani ukrytych kosztów. Towarzyszymy Ci na każdym etapie',
    why3_title: 'Wyjątkowa obsługa',
    why3_text: 'Dostępni dla Ciebie w każdej chwili, odpowiadamy na wszystkie pytania',
    location_badge: 'Nasza lokalizacja',
    location_title: 'Znajdź nas tutaj',
    location_sub: 'Odwiedź nasze biuro w Hurchillo, Alicante. Jesteśmy tu, aby pomóc Ci znaleźć idealną nieruchomość.',
    location_address_label: 'Adres',
    location_phone_label: 'Telefon / WhatsApp',
    location_email_label: 'E-mail',
    location_hours_label: 'Godziny otwarcia',
    location_hours1: 'Pon – Pt: 9:00 – 19:00',
    location_hours2: 'Sobota: 10:00 – 14:00',
    location_directions: 'Jak dojechać',
    location_desc: 'Znajdujemy się na rogu naprzeciwko kościoła, tuż obok Banco Caja Rural, w centrum Hurchillo.',
    blog_title: 'Nasz blog',
    blog_sub: 'Porady, przewodniki i aktualności o rynku nieruchomości na Costa Blanca',
    blog_read_more: 'Czytaj więcej',
    blog_see_all: 'Zobacz wszystkie artykuły',
    testimonials_badge: 'Opinie',
    testimonials_title: 'Co mówią\nnasi klienci',
    footer_newsletter_title: 'Bądź na bieżąco',
    footer_newsletter_sub: 'Zapisz się do naszego newslettera i otrzymuj najnowsze oferty nieruchomości bezpośrednio na swój e-mail.',
    footer_newsletter_placeholder: 'twoj@email.com',
    footer_newsletter_btn: 'Subskrybuj',
    footer_newsletter_sending: 'Wysyłanie...',
    footer_newsletter_success: 'Subskrypcja udana!',
    footer_newsletter_error: 'Błąd subskrypcji. Spróbuj ponownie.',
    footer_nav_label: 'Nawigacja',
    footer_contact_label: 'Kontakt',
    footer_privacy: 'Prywatność',
    footer_terms: 'Warunki',
    footer_rights: '© 2025 Red Lions Realty. Wszelkie prawa zastrzeżone.',
    nav_inicio_label: 'Strona główna', nav_destacados_label: 'Wyróżnione',
    nav_propiedades_label: 'Nieruchomości', nav_mapa_label: 'Mapa',
    nav_contacto_label: 'Kontakt', nav_nosotros_label: 'O nas',
    blog_page_title: 'Blog o nieruchomościach',
    blog_page_sub: 'Przewodniki, porady i aktualności o rynku nieruchomości na Costa Blanca',
    blog_search_placeholder: 'Szukaj artykułów...',
    blog_cat_all: 'Todas',
    blog_results_singular: 'artículo encontrado',
    blog_results_plural: 'artículos encontrados',
    blog_no_results_title: 'Aucun article trouvé',
    blog_no_results_sub: 'Essayez d\'autres termes de recherche ou catégories',
    blog_read_article: 'Lire l\'article',
    blog_footer_tagline: 'Il tuo partner di fiducia nel settore immobiliare della Costa Blanca',
    blog_footer_links: 'Link',
    blog_footer_follow: 'Seguici',
    blogpost_back: 'Voltar ao blog',
    blogpost_share: 'Compartir:',
    blogpost_share_liked: '¿Te gustó? Compártelo:',
    blogpost_copy: 'Copiar enlace',
    blogpost_copied: '¡Copiado!',
    blogpost_cta_title: 'Pronto a encontrar tu propiedad ideal?',
    blogpost_cta_sub: 'En Red Lions Realty te ayudamos a encontrar la propiedad perfecta en la Costa Blanca',
    blogpost_cta_btn: 'Ver propiedades',
    blogpost_related: 'Artículos relacionados',
    blogpost_read_article: 'Leer artículo',
    blogpost_not_found: 'Artículo no encontrado',
    blogpost_back_blog: 'Voltar ao blog',
    blogpost_nav_home: 'Strona główna',
    blogpost_nav_blog: 'Blog',
    blogpost_nav_contact: 'Skontaktuj się',
    blogpost_footer_tagline: 'Il tuo partner di fiducia nel settore immobiliare della Costa Blanca',
    blogpost_footer_contact: 'Contacto',
    blogpost_footer_offices: 'Uffici',
    blogpost_footer_follow: 'Seguici',
    blogpost_footer_rights: '© 2025 Red Lions Realty. Tutti i diritti riservati.',
    prop_back: 'Powrót do listy',
    prop_not_found_title: 'Nieruchomość nie znaleziona',
    prop_not_found_sub: 'Szukana nieruchomość nie istnieje lub została usunięta.',
    prop_not_found_btn: 'Powrót do strony głównej',
    prop_info_bedrooms: 'Sypialnie',
    prop_info_bathrooms: 'Łazienki',
    prop_info_area: 'Powierzchnia',
    prop_info_location: 'Lokalizacja',
    prop_info_description: 'Opis',
    prop_info_details: 'Szczegóły nieruchomości',
    prop_info_operation: 'Typ operacji',
    prop_info_reference: 'Referencja',
    prop_contact_price_note: 'Cena orientacyjna. Sprawdź dostępność.',
    prop_contact_whatsapp: 'Zapytaj na WhatsApp',
    prop_contact_form_title: 'Solicitar información',
    prop_contact_name: 'Tu nombre',
    prop_contact_email: 'Tu email',
    prop_contact_phone: 'Tu teléfono',
    prop_contact_interested: 'Tenho interesse em:',
    prop_contact_send: 'Enviar consulta',
    prop_contact_sending: 'A enviar...',
    prop_contact_success: 'Mensagem enviada! Entraremos em contacto.',
    prop_contact_error: 'Erro ao enviar. Por favor, tente novamente.',
    prop_footer_rights: '© 2025 Red Lions Realty. Todos los derechos reservados.',
  },
  fr: {
    nav_inicio: 'Accueil', nav_destacados: 'En vedette', nav_propiedades: 'Propriétés',
    nav_mapa: 'Carte', nav_contacto: 'Contact', nav_nosotros: 'À propos', nav_ubicacion: 'Localisation',
    nav_cta: 'Nous contacter', back: 'Retour à la liste',
    hero_title: 'Votre prochain chez-vous commence ici',
    hero_sub: 'Chez Red Lions Realty, nous transformons vos rêves immobiliers en réalité. Des propriétés de haute qualité dans les meilleures adresses d\'Alicante.',
    hero_btn1: 'Voir les propriétés', hero_btn2: 'Contacter',
    contact_label: 'WhatsApp', email_label: 'E-mail', location_label: 'Localisation',
    videos_badge: 'Vidéos',
    videos_title: '🎬 En vedette',
    videos_sub: 'Regardez nos propriétés en vidéo et découvrez tous les détails',
    videos_btn: 'Voir sur TikTok',
    videos_more: 'Voir plus sur TikTok',
    video1_type: 'Location · Local commercial',
    video1_desc: 'Le local commercial que vous cherchez',
    video2_type: 'Disponible · Local commercial',
    video2_desc: 'Vous cherchez un local pour votre entreprise ?',
    props_title: '🏠 Liste des propriétés',
    props_sub: 'Découvrez nos meilleures offres de vente et de location',
    props_found: 'propriété trouvée',
    props_found_pl: 'propriétés trouvées',
    props_active_filters: '· Filtres actifs',
    props_sorted: 'Trié par pertinence',
    props_see_detail: 'Voir le détail',
    props_gallery: 'Galerie photos',
    props_see_photos: 'Voir les photos',
    props_none_title: 'Aucune propriété trouvée',
    props_none_sub: 'Essayez d\'ajuster les filtres pour voir plus de résultats.',
    contact_title: 'Prêt à trouver votre prochain chez-vous ?',
    contact_sub: 'Contactez-nous aujourd\'hui et commencez votre recherche avec les meilleurs professionnels',
    contact_name: 'Votre nom',
    contact_email: 'Votre e-mail',
    contact_phone: 'Votre téléphone',
    contact_message: 'Dites-nous quel type de propriété vous recherchez...',
    contact_send: 'Envoyer le message',
    contact_sending: 'Envoi...',
    contact_success: 'Message envoyé avec succès ! Nous vous contacterons bientôt.',
    contact_error: 'Erreur d\'envoi. Veuillez réessayer.',
    about_badge: 'À propos',
    about_title: 'Red Lions Realty est votre partenaire de confiance sur le marché immobilier d\'Alicante ✨',
    about_sub: 'Forts de nombreuses années d\'expérience, nous nous spécialisons dans l\'offre de propriétés de haute qualité dans les meilleures localisations. Notre équipe de professionnels s\'engage à vous fournir un service personnalisé et transparent à chaque étape.',
    about_mission_title: 'Notre mission',
    about_mission_text: 'Aider nos clients à trouver la propriété parfaite adaptée à leurs besoins et à leur budget, offrend un service exceptionnel et des conseils d\'experts.',
    about_vision_title: 'Notre vision',
    about_vision_text: 'Être l\'agence immobilière leader à Alicante, reconnue pour notre intégrité, notre professionnalisme et notre engagement envers la satisfaction du client.',
    about_values_title: 'Nos valeurs',
    about_values_text: 'Transparence, honnêteté et dévouement dans chaque transaction. Nous construisons des relations durables basées sur la confiance et le respect mutuel.',
    why_title: 'Pourquoi nous choisir ?',
    why_sub: 'Nous offrons un service complet et personnalisé pour garantir votre satisfaction',
    why1_title: 'Recherche personnalisée',
    why1_text: 'Nous trouvons la propriété parfaite selon vos besoins spécifiques et votre budget',
    why2_title: 'Transparence totale',
    why2_text: 'Pas de surprises ni de coûts cachés. Nous vous accompagnons à chaque étape',
    why3_title: 'Service exceptionnel',
    why3_text: 'Disponibles pour vous à tout moment, répondant à toutes vos questions',
    location_badge: 'Notre emplacement',
    location_title: 'Trouvez-nous ici',
    location_sub: 'Rendez-nous visite dans notre bureau à Hurchillo, Alicante. Nous sommes là pour vous aider à trouver votre propriété idéale.',
    location_address_label: 'Adresse',
    location_phone_label: 'Téléphone / WhatsApp',
    location_email_label: 'E-mail',
    location_hours_label: 'Heures d\'ouverture',
    location_hours1: 'Lun – Ven : 9h00 – 19h00',
    location_hours2: 'Samedi : 10h00 – 14h00',
    location_directions: 'Itinéraire',
    location_desc: 'Nous sommes situés au coin en face de l\'église, juste à côté de la Banco Caja Rural, au centre de Hurchillo.',
    blog_title: 'Notre blog',
    blog_sub: 'Conseils, guides et actualités sur le marché immobilier de la Costa Blanca',
    blog_read_more: 'Lire la suite',
    blog_see_all: 'Voir tous les articles',
    testimonials_badge: 'Témoignages',
    testimonials_title: 'Ce que disent\nnos clients',
    footer_newsletter_title: 'Restez informé',
    footer_newsletter_sub: 'Abonnez-vous à notre newsletter et recevez les dernières propriétés et offres exclusives directement dans votre boîte mail.',
    footer_newsletter_placeholder: 'votre@email.com',
    footer_newsletter_btn: 'S\'abonner',
    footer_newsletter_sending: 'Envoi...',
    footer_newsletter_success: 'Abonnement réussi !',
    footer_newsletter_error: 'Erreur d\'abonnement. Réessayez.',
    footer_nav_label: 'Navigation',
    footer_contact_label: 'Contact',
    footer_privacy: 'Confidentialité',
    footer_terms: 'Conditions',
    footer_rights: '© 2025 Red Lions Realty. Tous droits réservés.',
    nav_inicio_label: 'Accueil', nav_destacados_label: 'En vedette',
    nav_propiedades_label: 'Propriétés', nav_mapa_label: 'Carte',
    nav_contacto_label: 'Contact', nav_nosotros_label: 'À propos',
    blog_page_title: 'Blog immobilier',
    blog_page_sub: 'Guides, conseils et actualités sur le marché immobilier de la Costa Blanca',
    blog_search_placeholder: 'Rechercher des articles...',
    blog_cat_all: 'Toutes',
    blog_results_singular: 'article trouvé',
    blog_results_plural: 'articles trouvés',
    blog_no_results_title: 'Aucun article trouvé',
    blog_no_results_sub: 'Essayez d\'autres termes de recherche ou catégories',
    blog_read_article: 'Lire l\'article',
    blog_footer_tagline: 'Votre partenaire de confiance sur le marché immobilier de la Costa Blanca',
    blog_footer_links: 'Liens',
    blog_footer_follow: 'Seguici',
    blogpost_back: 'Retour au blog',
    blogpost_share: 'Partager :',
    blogpost_share_liked: 'Vous avez aimé ? Partagez :',
    blogpost_copy: 'Copier le lien',
    blogpost_copied: 'Copié !',
    blogpost_cta_title: 'Pronto a encontrar tu propiedad ideal?',
    blogpost_cta_sub: 'En Red Lions Realty te ayudamos a encontrar la propiedad perfecta en la Costa Blanca',
    blogpost_cta_btn: 'Voir les propriétés',
    blogpost_related: 'Artículos relacionados',
    blogpost_read_article: 'Leer artículo',
    blogpost_not_found: 'Artículo no encontrado',
    blogpost_back_blog: 'Retour au blog',
    blogpost_nav_home: 'Accueil',
    blogpost_nav_blog: 'Blog',
    blogpost_nav_contact: 'Nous contacter',
    blogpost_footer_tagline: 'Votre partenaire de confiance en immobilier sur la Costa Blanca',
    blogpost_footer_contact: 'Contact',
    blogpost_footer_offices: 'Bureaux',
    blogpost_footer_follow: 'Seguici',
    blogpost_footer_rights: '© 2025 Red Lions Realty. Tous droits réservés.',
    prop_back: 'Retour à la liste',
    prop_not_found_title: 'Propriété introuvable',
    prop_not_found_sub: 'La propriété que vous cherchez n\'existe pas ou a été supprimée.',
    prop_not_found_btn: 'Retour à l\'accueil',
    prop_info_bedrooms: 'Chambres',
    prop_info_bathrooms: 'Salles de bain',
    prop_info_area: 'Surface',
    prop_info_location: 'Localisation',
    prop_info_description: 'Description',
    prop_info_details: 'Détails de la propriété',
    prop_info_operation: 'Type d\'opération',
    prop_info_reference: 'Référence',
    prop_contact_price_note: 'Prix indicatif. Vérifiez la disponibilité.',
    prop_contact_whatsapp: 'Demander sur WhatsApp',
    prop_contact_form_title: 'Demander des informations',
    prop_contact_name: 'Votre nom',
    prop_contact_email: 'Votre e-mail',
    prop_contact_phone: 'Votre téléphone',
    prop_contact_interested: 'Je suis intéressé par :',
    prop_contact_send: 'Envoyer la demande',
    prop_contact_sending: 'Envoi...',
    prop_contact_success: 'Message envoyé! Nous vous contacterons bientôt.',
    prop_contact_error: 'Erreur d\'envoi. Veuillez réessayer.',
    prop_footer_rights: '© 2025 Red Lions Realty. Tous droits réservés.',
  },
  de: {
    nav_inicio: 'Startseite', nav_destacados: 'Highlights', nav_propiedades: 'Immobilien',
    nav_mapa: 'Karte', nav_contacto: 'Kontakt', nav_nosotros: 'Über uns', nav_ubicacion: 'Standort',
    nav_cta: 'Kontaktieren', back: 'Zurück zur Liste',
    hero_title: 'Ihr nächstes Zuhause beginnt hier',
    hero_sub: 'Bei Red Lions Realty verwandeln wir Ihre Immobilienträume in Wirklichkeit. Hochwertige Immobilien in den besten Lagen Alicantes.',
    hero_btn1: 'Immobilien ansehen', hero_btn2: 'Kontakt',
    contact_label: 'WhatsApp', email_label: 'E-Mail', location_label: 'Standort',
    videos_badge: 'Videos',
    videos_title: '🎬 Highlights',
    videos_sub: 'Sehen Sie unsere Immobilien im Video und entdecken Sie alle Details',
    videos_btn: 'Video auf TikTok ansehen',
    videos_more: 'Mehr auf TikTok',
    video1_type: 'Miete · Gewerberaum',
    video1_desc: 'Der Gewerberaum, den Sie suchen',
    video2_type: 'Verfügbar · Gewerberaum',
    video2_desc: 'Suchen Sie einen Raum für Ihr Unternehmen?',
    props_title: '🏠 Immobilienliste',
    props_sub: 'Entdecken Sie unsere besten Kauf- und Mietangebote',
    props_found: 'Immobilie gefunden',
    props_found_pl: 'Immobilien gefunden',
    props_active_filters: '· Aktive Filter',
    props_sorted: 'Nach Relevanz sortiert',
    props_see_detail: 'Details ansehen',
    props_gallery: 'Fotogalerie',
    props_see_photos: 'Fotos ansehen',
    props_none_title: 'Keine Immobilien gefunden',
    props_none_sub: 'Versuchen Sie, die Filter anzupassen, um mehr Ergebnisse zu sehen.',
    contact_title: 'Bereit, Ihr nächstes Zuhause zu finden?',
    contact_sub: 'Kontaktieren Sie uns noch heute und beginnen Sie Ihre Suche mit den besten Fachleuten',
    contact_name: 'Ihr Name',
    contact_email: 'Ihre E-Mail',
    contact_phone: 'Ihre Telefonnummer',
    contact_message: 'Erzählen Sie uns, welche Art von Immobilie Sie suchen...',
    contact_send: 'Nachricht senden',
    contact_sending: 'Senden...',
    contact_success: 'Nachricht erfolgreich gesendet! Wir melden uns bald.',
    contact_error: 'Fehler beim Senden. Bitte versuchen Sie es erneut.',
    about_badge: 'Über uns',
    about_title: 'Red Lions Realty ist Ihr vertrauenswürdiger Partner auf dem Immobilienmarkt in Alicante ✨',
    about_sub: 'Mit jahrelanger Erfahrung in der Branche sind wir auf hochwertige Immobilien in den besten Lagen spezialisiert. Unser Expertenteam bietet Ihnen personalisierten und transparenten Service bei jedem Schritt.',
    about_mission_title: 'Unsere Mission',
    about_mission_text: 'Unseren Kunden helfen, die perfekte Immobilie zu finden, die ihren Bedürfnissen und ihrem Budget entspricht, mit außergewöhnlichem Service und Expertenberatung.',
    about_vision_title: 'Unsere Vision',
    about_vision_text: 'Die führende Immobilienagentur in Alicante zu sein, bekannt für Integrität, Professionalität und Engagement für Kundenzufriedenheit.',
    about_values_title: 'Unsere Werte',
    about_values_text: 'Transparenz, Ehrlichkeit und Hingabe bei jeder Transaktion. Wir bauen dauerhafte Beziehungen auf der Grundlage von Vertrauen und gegenseitigem Respekt auf.',
    why_title: 'Warum uns wählen?',
    why_sub: 'Wir bieten einen umfassenden und personalisierten Service, um Ihre Zufriedenheit zu garantieren',
    why1_title: 'Personalisierte Suche',
    why1_text: 'Wir finden die perfekte Immobilie entsprechend Ihren spezifischen Bedürfnissen und Ihrem Budget',
    why2_title: 'Volle Transparenz',
    why2_text: 'Keine Überraschungen oder versteckten Kosten. Wir begleiten Sie bei jedem Schritt',
    why3_title: 'Außergewöhnlicher Service',
    why3_text: 'Jederzeit für Sie verfügbar, beantworten wir alle Ihre Fragen',
    location_badge: 'Unser Standort',
    location_title: 'Finden Sie uns hier',
    location_sub: 'Besuchen Sie uns in unserem Büro in Hurchillo, Alicante. Wir helfen Ihnen, Ihre ideale Immobilie zu finden.',
    location_address_label: 'Adresse',
    location_phone_label: 'Telefon / WhatsApp',
    location_email_label: 'E-Mail',
    location_hours_label: 'Öffnungszeiten',
    location_hours1: 'Mo – Fr: 9:00 – 19:00',
    location_hours2: 'Samstag: 10:00 – 14:00',
    location_directions: 'Wegbeschreibung',
    location_desc: 'Wir befinden uns an der Ecke gegenüber der Kirche, direkt neben der Banco Caja Rural, im Zentrum von Hurchillo.',
    blog_title: 'Unser Blog',
    blog_sub: 'Tipps, Ratgeber und Neuigkeiten über den Immobilienmarkt an der Costa Blanca',
    blog_read_more: 'Mehr lesen',
    blog_see_all: 'Alle Artikel ansehen',
    testimonials_badge: 'Referenzen',
    testimonials_title: 'Was unsere\nKunden sagen',
    footer_newsletter_title: 'Bleiben Sie informiert',
    footer_newsletter_sub: 'Abonnieren Sie unseren Newsletter und erhalten Sie die neuesten Immobilien und exklusiven Angebote direkt in Ihr Postfach.',
    footer_newsletter_placeholder: 'ihre@email.com',
    footer_newsletter_btn: 'Abonnieren',
    footer_newsletter_sending: 'Senden...',
    footer_newsletter_success: 'Abonnement erfolgreich!',
    footer_newsletter_error: 'Abonnementfehler. Bitte versuchen Sie es erneut.',
    footer_nav_label: 'Navigation',
    footer_contact_label: 'Kontakt',
    footer_privacy: 'Datenschutz',
    footer_terms: 'Bedingungen',
    footer_rights: '© 2025 Red Lions Realty. Alle Rechte vorbehalten.',
    nav_inicio_label: 'Startseite', nav_destacados_label: 'Highlights',
    nav_propiedades_label: 'Immobilien', nav_mapa_label: 'Karte',
    nav_contacto_label: 'Kontakt', nav_nosotros_label: 'Über uns',
    blog_page_title: 'Immobilien-Blog',
    blog_page_sub: 'Ratgeber, Tipps und Neuigkeiten über den Immobilienmarkt an der Costa Blanca',
    blog_search_placeholder: 'Artikel suchen...',
    blog_cat_all: 'Alle',
    blog_results_singular: 'Artikel gefunden',
    blog_results_plural: 'Artikel gefunden',
    blog_no_results_title: 'Keine Artikel gefunden',
    blog_no_results_sub: 'Versuchen Sie andere Suchbegriffe oder Kategorien',
    blog_read_article: 'Artikel lesen',
    blog_footer_tagline: 'Ihr vertrauenswürdiger Partner auf dem Immobilienmarkt der Costa Blanca',
    blog_footer_links: 'Links',
    blog_footer_follow: 'Folgen Sie uns',
    blogpost_back: 'Zurück zum Blog',
    blogpost_share: 'Teilen:',
    blogpost_share_liked: 'Hat es Ihnen gefallen? Teilen Sie es:',
    blogpost_copy: 'Link kopieren',
    blogpost_copied: 'Copié !',
    blogpost_cta_title: 'Pronto a encontrar tu propiedad ideal?',
    blogpost_cta_sub: 'En Red Lions Realty helfen wir Ihnen, die perfekte Immobilie an der Costa Blanca zu finden',
    blogpost_cta_btn: 'Immobilien ansehen',
    blogpost_related: 'Ähnliche Artikel',
    blogpost_read_article: 'Artikel lesen',
    blogpost_not_found: 'Artikel nicht gefunden',
    blogpost_back_blog: 'Zurück zum Blog',
    blogpost_nav_home: 'Startseite',
    blogpost_nav_blog: 'Blog',
    blogpost_nav_contact: 'Kontaktieren',
    blogpost_footer_tagline: 'Ihr vertrauenswürdiger Partner für Immobilien an der Costa Blanca',
    blogpost_footer_contact: 'Kontakt',
    blogpost_footer_offices: 'Büros',
    blogpost_footer_follow: 'Folgen Sie uns',
    blogpost_footer_rights: '© 2025 Red Lions Realty. Alle Rechte vorbehalten.',
    prop_back: 'Zurück zur Liste',
    prop_not_found_title: 'Immobilie nicht gefunden',
    prop_not_found_sub: 'Die gesuchte Immobilie existiert nicht oder wurde entfernt.',
    prop_not_found_btn: 'Zurück zur Startseite',
    prop_info_bedrooms: 'Schlafzimmer',
    prop_info_bathrooms: 'Badezimmer',
    prop_info_area: 'Fläche',
    prop_info_location: 'Standort',
    prop_info_description: 'Beschreibung',
    prop_info_details: 'Immobiliendetails',
    prop_info_operation: 'Operationstyp',
    prop_info_reference: 'Referenz',
    prop_contact_price_note: 'Richtpreis. Verfügbarkeit prüfen.',
    prop_contact_whatsapp: 'Per WhatsApp anfragen',
    prop_contact_form_title: 'Informationen anfordern',
    prop_contact_name: 'Ihr Name',
    prop_contact_email: 'Ihre E-Mail',
    prop_contact_phone: 'Ihre Telefonnummer',
    prop_contact_interested: 'Ich interessiere mich für:',
    prop_contact_send: 'Anfrage senden',
    prop_contact_sending: 'Senden...',
    prop_contact_success: 'Nachricht gesendet! Wir melden uns bald.',
    prop_contact_error: 'Fehler beim Senden. Veuillez erneut versuchen.',
    prop_footer_rights: '© 2025 Red Lions Realty. Alle Rechte vorbehalten.',
  },
  pt: {
    nav_inicio: 'Início', nav_destacados: 'Destaques', nav_propiedades: 'Propriedades',
    nav_mapa: 'Mapa', nav_contacto: 'Contato', nav_nosotros: 'Sobre nós', nav_ubicacion: 'Localização',
    nav_cta: 'Fale conosco', back: 'Voltar à lista',
    hero_title: 'A sua próxima casa começa aqui',
    hero_sub: 'Na Red Lions Realty, transformamos os seus sonhos imobiliários em realidade. Propriedades de alta qualidade nas melhores localizações de Alicante.',
    hero_btn1: 'Ver propriedades', hero_btn2: 'Contato',
    contact_label: 'WhatsApp', email_label: 'E-mail', location_label: 'Localização',
    videos_badge: 'Vídeos',
    videos_title: '🎬 Destaques',
    videos_sub: 'Veja as nossas propriedades em vídeo e descubra todos os detalhes',
    videos_btn: 'Ver no TikTok',
    videos_more: 'Ver mais no TikTok',
    video1_type: 'Aluguel · Espaço Comercial',
    video1_desc: 'O espaço comercial que você procura',
    video2_type: 'Disponível · Espaço Comercial',
    video2_desc: 'Procura um espaço para o seu negócio?',
    props_title: '🏠 Lista de propriedades',
    props_sub: 'Descubra as nossas melhores ofertas de venda e aluguel',
    props_found: 'propriedade encontrada',
    props_found_pl: 'propriedades encontradas',
    props_active_filters: '· Filtros ativos',
    props_sorted: 'Ordenado por relevância',
    props_see_detail: 'Ver detalhe',
    props_gallery: 'Galeria de fotos',
    props_see_photos: 'Ver fotos',
    props_none_title: 'Nenhuma propriedade encontrada',
    props_none_sub: 'Tente ajustar os filtros para ver mais resultados.',
    contact_title: 'Pronto para encontrar a sua próxima casa?',
    contact_sub: 'Contacte-nos hoje e comece a sua pesquisa com os melhores profissionais',
    contact_name: 'O seu nome',
    contact_email: 'O seu e-mail',
    contact_phone: 'O seu telefone',
    contact_message: 'Diga-nos que tipo de propriedade procura...',
    contact_send: 'Enviar mensagem',
    contact_sending: 'A enviar...',
    contact_success: 'Mensagem enviada com sucesso! Entraremos em contacto em breve.',
    contact_error: 'Erro ao enviar. Por favor, tente novamente.',
    about_badge: 'Sobre nós',
    about_title: 'Red Lions Realty é o seu parceiro de confiança no mercado imobiliário de Alicante ✨',
    about_sub: 'Com anos de experiência no setor, especializamo-nos em oferecer propriedades de alta qualidade nas melhores localizações. A nossa equipa de profissionais está comprometida a fornecer um serviço personalizado e transparente em cada fase.',
    about_mission_title: 'A nossa missão',
    about_mission_text: 'Ajudar os nossos clientes a encontrar a propriedade perfeita que se adapte às suas necessidades e orçamento, oferecendo um serviço excepcional e aconselhamento especializado.',
    about_vision_title: 'A nossa visão',
    about_vision_text: 'Ser a agência imobiliária líder em Alicante, reconhecida pela nossa integridade, profissionalismo e compromisso com a satisfação do cliente.',
    about_values_title: 'Os nossos valores',
    about_values_text: 'Transparência, honestidade e dedicação em cada transação. Construímos relações duradouras baseadas na confiança e no respeito mútuo.',
    why_title: 'Porquê escolher-nos?',
    why_sub: 'Oferecemos um serviço abrangente e personalizado para garantir a sua satisfação',
    why1_title: 'Pesquisa personalizada',
    why1_text: 'Encontramos a propriedade perfeita de acordo com as suas necessidades específicas e orçamento',
    why2_title: 'Transparência total',
    why2_text: 'Sem surpresas ou custos ocultos. Acompanhamo-lo em cada etapa do processo',
    why3_title: 'Serviço excepcional',
    why3_text: 'Disponíveis para si a qualquer momento, respondendo a todas as suas dúvidas',
    location_badge: 'A nossa localização',
    location_title: 'Encontre-nos aqui',
    location_sub: 'Visite-nos no nosso escritório em Hurchillo, Alicante. Estamos aqui para o ajudar a encontrar a sua propriedade ideal.',
    location_address_label: 'Morada',
    location_phone_label: 'Telefone / WhatsApp',
    location_email_label: 'E-mail',
    location_hours_label: 'Horário de atendimento',
    location_hours1: 'Seg – Sex: 9:00 – 19:00',
    location_hours2: 'Sábado: 10:00 – 14:00',
    location_directions: 'Como chegar',
    location_desc: 'Estamos localizados na esquina em frente à igreja, mesmo ao lado do Banco Caja Rural, no centro de Hurchillo.',
    blog_title: 'O nosso blog',
    blog_sub: 'Dicas, guias e novidades sobre o mercado imobiliário na Costa Blanca',
    blog_read_more: 'Ler mais',
    blog_see_all: 'Ver todos os artigos',
    testimonials_badge: 'Testemunhos',
    testimonials_title: 'O que dizem\ni nossos clientes',
    footer_newsletter_title: 'Mantenha-se informado',
    footer_newsletter_sub: 'Subscreva a nossa newsletter e receba as últimas propriedades e ofertas exclusivas diretamente no seu e-mail.',
    footer_newsletter_placeholder: 'seu@email.com',
    footer_newsletter_btn: 'Subscrever',
    footer_newsletter_sending: 'A enviar...',
    footer_newsletter_success: 'Subscrição bem-sucedida!',
    footer_newsletter_error: 'Erro na subscrição. Tente novamente.',
    footer_nav_label: 'Navegação',
    footer_contact_label: 'Contacto',
    footer_privacy: 'Privacidade',
    footer_terms: 'Termos',
    footer_rights: '© 2025 Red Lions Realty. Todos os direitos reservados.',
    nav_inicio_label: 'Início', nav_destacados_label: 'Destaques',
    nav_propiedades_label: 'Propriedades', nav_mapa_label: 'Mapa',
    nav_contacto_label: 'Contacto', nav_nosotros_label: 'Sobre nós',
    blog_page_title: 'Blog imobiliário',
    blog_page_sub: 'Guias, dicas e novidades sobre o mercado imobiliário na Costa Blanca',
    blog_search_placeholder: 'Pesquisar artigos...',
    blog_cat_all: 'Todas',
    blog_results_singular: 'artigo encontrado',
    blog_results_plural: 'artigos encontrados',
    blog_no_results_title: 'Nenhum artigo encontrado',
    blog_no_results_sub: 'Tente outros termos de pesquisa ou categorias',
    blog_read_article: 'Ler artigo',
    blog_footer_tagline: 'O seu parceiro de confiança no mercado imobiliário da Costa Blanca',
    blog_footer_links: 'Links',
    blog_footer_follow: 'Seguici',
    blogpost_back: 'Voltar ao blog',
    blogpost_share: 'Partilhar:',
    blogpost_share_liked: 'Gostou? Partilhe:',
    blogpost_copy: 'Copiar link',
    blogpost_copied: 'Copiado!',
    blogpost_cta_title: 'Pronto para encontrar a sua propriedade ideal?',
    blogpost_cta_sub: 'Na Red Lions Realty ajudamos a encontrar a propriedade perfeita na Costa Blanca',
    blogpost_cta_btn: 'Ver propriedades',
    blogpost_related: 'Artigos relacionados',
    blogpost_read_article: 'Ler artigo',
    blogpost_not_found: 'Artigo não encontrado',
    blogpost_back_blog: 'Voltar ao blog',
    blogpost_nav_home: 'Início',
    blogpost_nav_blog: 'Blog',
    blogpost_nav_contact: 'Fale conosco',
    blogpost_footer_tagline: 'O seu parceiro de confiança em imobiliário na Costa Blanca',
    blogpost_footer_contact: 'Contacto',
    blogpost_footer_offices: 'Escritórios',
    blogpost_footer_follow: 'Seguici',
    blogpost_footer_rights: '© 2025 Red Lions Realty. Todos os direitos reservados.',
    prop_back: 'Voltar à lista',
    prop_not_found_title: 'Propriedade não encontrada',
    prop_not_found_sub: 'A propriedade que procura não existe ou foi removida.',
    prop_not_found_btn: 'Voltar ao início',
    prop_info_bedrooms: 'Quartos',
    prop_info_bathrooms: 'Casas de banho',
    prop_info_area: 'Área',
    prop_info_location: 'Localização',
    prop_info_description: 'Descrição',
    prop_info_details: 'Detalhes da propriedade',
    prop_info_operation: 'Tipo de operação',
    prop_info_reference: 'Referência',
    prop_contact_price_note: 'Preço indicativo. Verifique disponibilidade.',
    prop_contact_whatsapp: 'Zapytaj na WhatsApp',
    prop_contact_form_title: 'Solicitar informações',
    prop_contact_name: 'O seu nome',
    prop_contact_email: 'O seu e-mail',
    prop_contact_phone: 'O seu telefone',
    prop_contact_interested: 'Tenho interesse em:',
    prop_contact_send: 'Enviar consulta',
    prop_contact_sending: 'A enviar...',
    prop_contact_success: 'Mensagem enviada! Entraremos em contacto.',
    prop_contact_error: 'Erro ao enviar. Tente novamente.',
    prop_footer_rights: '© 2025 Red Lions Realty. Todos os direitos reservados.',
  },
  it: {
    nav_inicio: 'Home', nav_destacados: 'In evidenza', nav_propiedades: 'Proprietà',
    nav_mapa: 'Mappa', nav_contacto: 'Contatto', nav_nosotros: 'Chi siamo', nav_ubicacion: 'Posizione',
    nav_cta: 'Contattaci', back: 'Torna all\'elenco',
    hero_title: 'La tua prossima casa inizia qui',
    hero_sub: 'Da Red Lions Realty, trasformiamo i tuoi sogni immobiliari in realidade. Proprietà di alta qualità nelle migliori posizioni di Alicante.',
    hero_btn1: 'Vedi proprietà', hero_btn2: 'Contatto',
    contact_label: 'WhatsApp', email_label: 'E-mail', location_label: 'Posizione',
    videos_badge: 'Video',
    videos_title: '🎬 In evidenza',
    videos_sub: 'Guarda le nostre proprietà in video e scopri tutti i dettagli',
    videos_btn: 'Guarda su TikTok',
    videos_more: 'Vedi altro su TikTok',
    video1_type: 'Affitto · Locale commerciale',
    video1_desc: 'Il locale commerciale che stai cercando',
    video2_type: 'Disponibile · Locale commerciale',
    video2_desc: 'Cerchi uno spazio per la tua attività?',
    props_title: '🏠 Elenco proprietà',
    props_sub: 'Scopri le nostre migliori offerte di vendita e affitto',
    props_found: 'proprietà trovata',
    props_found_pl: 'proprietà trovate',
    props_active_filters: '· Filtri attivi',
    props_sorted: 'Ordinato per rilevanza',
    props_see_detail: 'Vedi dettaglio',
    props_gallery: 'Galleria foto',
    props_see_photos: 'Vedi foto',
    props_none_title: 'Nessuna proprietà trovata',
    props_none_sub: 'Prova a modificare i filtri per vedere più risultati.',
    contact_title: 'Pronto a trovare la tua prossima casa?',
    contact_sub: 'Contattaci oggi e inizia la tua ricerca con i migliori professionisti',
    contact_name: 'Il tuo nome',
    contact_email: 'La tua e-mail',
    contact_phone: 'Il tuo telefono',
    contact_message: 'Dica-nos, che tipo di proprietà stai cercando...',
    contact_send: 'Invia messaggio',
    contact_sending: 'Invio...',
    contact_success: 'Messaggio inviato con successo! Ti contatteremo presto.',
    contact_error: 'Errore nell\'invio. Per favore riprova.',
    about_badge: 'Chi siamo',
    about_title: 'Red Lions Realty è il tuo partner di fiducia nel mercato immobiliare di Alicante ✨',
    about_sub: 'Con anni di esperienza nel settore, siamo specializzati nell\'offrire proprietà di alta qualità nelle migliori posizioni. Il nostro team di professionisti si impegna a fornirti un servizio personalizzato e transparente in ogni fase.',
    about_mission_title: 'La nostra missione',
    about_mission_text: 'Aiutare i nostri clienti a trovare la proprietà perfetta dopasata alle loro esigenze e al loro budget, offrendo un servizio eccezionale e consulenza esperta.',
    about_vision_title: 'La nostra visione',
    about_vision_text: 'Essere l\'agenzia immobiliare leader ad Alicante, riconosciuta per la nostra integrità, professionalità e impegno per la soddisfazione del cliente.',
    about_values_title: 'I nostri valori',
    about_values_text: 'Transpareza, onestà e dedizione in ogni transazione. Costruiamo relazioni durature basate sulla fiducia e sul rispetto reciproco.',
    why_title: 'Perché sceglierci?',
    why_sub: 'Offriamo un servizio completo e personalizzato per garantire la tua soddisfazione',
    why1_title: 'Ricerca personalizzata',
    why1_text: 'Troviamo la proprietà perfetta in base alle tue esigenze specifiche e al tuo budget',
    why2_title: 'Piena trasparenza',
    why2_text: 'Nessuna sorpresa né costi nascosti. Ti accompagniamo in ogni fase',
    why3_title: 'Servizio eccezionale',
    why3_text: 'Disponibili per te in qualsiasi momento, rispondendo a tutte le tue domande',
    location_badge: 'La nostra posizione',
    location_title: 'Trovaci qui',
    location_sub: 'Visitaci nel nostro ufficio a Hurchillo, Alicante. Siamo qui per aiutarti a trovare la tua proprietà ideale.',
    location_address_label: 'Indirizzo',
    location_phone_label: 'Telefono / WhatsApp',
    location_email_label: 'E-mail',
    location_hours_label: 'Orari di apertura',
    location_hours1: 'Lun – Ven: 9:00 – 19:00',
    location_hours2: 'Sabato: 10:00 – 14:00',
    location_directions: 'Come arrivare',
    location_desc: 'Ci troviamo all\'angolo di fronte alla chiesa, proprio accanto alla Banco Caja Rural, nel centro di Hurchillo.',
    blog_title: 'Il nostro blog',
    blog_sub: 'Consigli, guide e novità sul mercato immobiliare della Costa Blanca',
    blog_read_more: 'Leggi di più',
    blog_see_all: 'Vedi tutti gli articoli',
    testimonials_badge: 'Opinie',
    testimonials_title: 'Cosa dicono\ni nostri clienti',
    footer_newsletter_title: 'Rimani informato',
    footer_newsletter_sub: 'Iscriviti alla nostra newsletter e ricevi le ultime proprietà e offerte esclusive direttamente nella tua casella di posta.',
    footer_newsletter_placeholder: 'tua@email.com',
    footer_newsletter_btn: 'Iscriviti',
    footer_newsletter_sending: 'Invio...',
    footer_newsletter_success: 'Iscrizione riuscita!',
    footer_newsletter_error: 'Errore di iscrizione. Riprova.',
    footer_nav_label: 'Navigazione',
    footer_contact_label: 'Contatto',
    footer_privacy: 'Confidenzialità',
    footer_terms: 'Termini',
    footer_rights: '© 2025 Red Lions Realty. Tutti i diritti riservati.',
    nav_inicio_label: 'Home', nav_destacados_label: 'In evidenza',
    nav_propiedades_label: 'Proprietà', nav_mapa_label: 'Mappa',
    nav_contacto_label: 'Contatto', nav_nosotros_label: 'Chi siamo',
    blog_page_title: 'Blog immobiliare',
    blog_page_sub: 'Guide, consigli e novità sul mercato immobiliare della Costa Blanca',
    blog_search_placeholder: 'Cerca articoli...',
    blog_cat_all: 'Tutte',
    blog_results_singular: 'articolo trovato',
    blog_results_plural: 'articoli trovati',
    blog_no_results_title: 'Nessun articolo trovato',
    blog_no_results_sub: 'Prova altri termini di ricerca o categorie',
    blog_read_article: 'Leggi articolo',
    blog_footer_tagline: 'Il tuo partner di fiducia nel mercato immobiliare della Costa Blanca',
    blog_footer_links: 'Link',
    blog_footer_follow: 'Seguici',
    blogpost_back: 'Torna al blog',
    blogpost_share: 'Condividi:',
    blogpost_share_liked: 'Ti è piaciuto? Condividilo:',
    blogpost_copy: 'Copia link',
    blogpost_copied: 'Copiato!',
    blogpost_cta_title: 'Pronto a trovare la tua proprietà ideale?',
    blogpost_cta_sub: 'Da Red Lions Realty ti aiutiamo a trovare la proprietà perfetta sulla Costa Blanca',
    blogpost_cta_btn: 'Vedi proprietà',
    blogpost_related: 'Articoli correlati',
    blogpost_read_article: 'Leggi articolo',
    blogpost_not_found: 'Articolo non trovato',
    blogpost_back_blog: 'Torna al blog',
    blogpost_nav_home: 'Home',
    blogpost_nav_blog: 'Blog',
    blogpost_nav_contact: 'Contattaci',
    blogpost_footer_tagline: 'Il tuo partner di fiducia nel settore immobiliare della Costa Blanca',
    blogpost_footer_contact: 'Contatto',
    blogpost_footer_offices: 'Uffici',
    blogpost_footer_follow: 'Seguici',
    blogpost_footer_rights: '© 2025 Red Lions Realty. Tutti i diritti riservati.',
    prop_back: 'Torna all\'elenco',
    prop_not_found_title: 'Proprietà non trovata',
    prop_not_found_sub: 'La proprietà che cerchi non esiste o è stata rimossa.',
    prop_not_found_btn: 'Torna alla home',
    prop_info_bedrooms: 'Camere da letto',
    prop_info_bathrooms: 'Bagni',
    prop_info_area: 'Superficie',
    prop_info_location: 'Ubicación',
    prop_info_description: 'Descripción',
    prop_info_details: 'Detalles de la propiedad',
    prop_info_operation: 'Tipo de operación',
    prop_info_reference: 'Referencia',
    prop_contact_price_note: 'Preço indicativo. Verifique disponibilidade.',
    prop_contact_whatsapp: 'Zapytaj na WhatsApp',
    prop_contact_form_title: 'Solicitar información',
    prop_contact_name: 'O seu nome',
    prop_contact_email: 'O seu e-mail',
    prop_contact_phone: 'O seu telefone',
    prop_contact_interested: 'Tenho interesse em:',
    prop_contact_send: 'Enviar consulta',
    prop_contact_sending: 'A enviar...',
    prop_contact_success: 'Mensagem enviada! Entraremos em contacto.',
    prop_contact_error: 'Erro ao enviar. Por favor, tente novamente.',
    prop_footer_rights: '© 2025 Red Lions Realty. Todos los derechos reservados.',
  },
};

export type LangCode = keyof typeof translations;

export function getTranslation(lang: LangCode, key: string): string {
  return translations[lang]?.[key] ?? translations['es'][key] ?? key;
}

export { translations };

interface LanguageSelectorProps {
  currentLang: LangCode;
  onChangeLang: (lang: LangCode) => void;
  scrolled?: boolean;
}

export default function LanguageSelector({ currentLang, onChangeLang, scrolled = true }: LanguageSelectorProps) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  const current = languages.find(l => l.code === currentLang) ?? languages[0];

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  return (
    <div ref={ref} className="relative">
      <button
        onClick={() => setOpen(!open)}
        className={`flex items-center gap-2 px-3 py-2 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap border ${
          scrolled
            ? 'border-gray-200 text-gray-700 hover:border-red-300 hover:text-red-600 bg-white'
            : 'border-white/30 text-white hover:border-white bg-white/10'
        }`}
      >
        <span className="text-lg leading-none">{current.flag}</span>
        <span className="hidden sm:inline">{current.label}</span>
        <i className={`ri-arrow-down-s-line text-base transition-transform duration-200 ${open ? 'rotate-180' : ''}`}></i>
      </button>

      {open && (
        <div className="absolute right-0 top-full mt-2 w-44 bg-white rounded-2xl shadow-2xl border border-gray-100 overflow-hidden z-[100] animate-fade-in">
          {languages.map((lang) => (
            <button
              key={lang.code}
              onClick={() => { onChangeLang(lang.code as LangCode); setOpen(false); }}
              className={`w-full flex items-center gap-3 px-4 py-3 text-sm font-medium transition-colors cursor-pointer hover:bg-red-50 hover:text-red-600 ${
                currentLang === lang.code ? 'bg-red-50 text-red-600' : 'text-gray-700'
              }`}
            >
              <span className="text-xl leading-none">{lang.flag}</span>
              <span>{lang.label}</span>
              {currentLang === lang.code && (
                <i className="ri-check-line ml-auto text-red-600"></i>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
